import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axiosClient from '../../api/axiosClient';
import { Mail, Trash2, User, Clock,  MapPin } from 'lucide-react';

const ContactMessagesPage = () => {
  const queryClient = useQueryClient();

  // Fetch Messages
  const { data: messages = [], isLoading } = useQuery({
    queryKey: ['contactMessages'],
    queryFn: () => axiosClient.get('/admin/contact/messages')
  });

  // Delete Mutation
  const deleteMutation = useMutation({
    mutationFn: (id) => axiosClient.delete(`/admin/contact/messages/${id}`),
    onSuccess: () => {
        queryClient.invalidateQueries(['contactMessages']);
        alert("Message Deleted.");
    }
  });

  return (
    <div className="space-y-6 animate-fade-in pb-10">
      
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-slate-800 flex items-center">
            <Mail className="w-6 h-6 text-blue-600 mr-3" />
            Contact Inquiries
          </h1>
          <p className="text-sm text-slate-500">Messages received from the public website.</p>
        </div>
      </div>

      {/* Messages List */}
      <div className="grid grid-cols-1 gap-4">
        {isLoading ? (
             <div className="p-10 text-center text-slate-400">Loading Inbox...</div>
        ) : messages.length === 0 ? (
             <div className="p-10 text-center bg-white rounded-xl border border-slate-200 text-slate-400">
                No new messages.
             </div>
        ) : (
            messages.map((msg) => (
                <div key={msg.id} className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow group">
                    <div className="flex justify-between items-start mb-4">
                        <div className="flex items-center space-x-3">
                            <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center text-blue-600">
                                <User className="w-5 h-5" />
                            </div>
                            <div>
                                <h3 className="font-bold text-slate-800">{msg.name}</h3>
                                <p className="text-xs text-blue-600 font-medium">{msg.email}</p>
                            </div>
                        </div>
                        <div className="flex items-center text-xs text-slate-400">
                            <Clock className="w-3 h-3 mr-1" />
                            {new Date(msg.created_at).toLocaleString()}
                        </div>
                    </div>

                    <div className="pl-13 ml-1">
                        <h4 className="text-sm font-bold text-slate-700 mb-2">{msg.subject}</h4>
                        <p className="text-sm text-slate-600 bg-slate-50 p-4 rounded-lg leading-relaxed border border-slate-100">
                            {msg.message}
                        </p>
                    </div>

                    <div className="flex justify-between items-center mt-4 pt-4 border-t border-slate-100">
                        <div className="flex items-center text-xs text-slate-400">
                            <MapPin className="w-3 h-3 mr-1" /> IP: <span className="font-mono ml-1 bg-slate-100 px-2 py-0.5 rounded">{msg.ip_address || 'Unknown'}</span>
                        </div>
                        <button 
                           onClick={() => { if(window.confirm('Delete this message?')) deleteMutation.mutate(msg.id) }}
                           className="text-slate-400 hover:text-red-600 transition-colors p-2 hover:bg-red-50 rounded-lg"
                        >
                           <Trash2 className="w-4 h-4" />
                        </button>
                    </div>
                </div>
            ))
        )}
      </div>
    </div>
  );
};

export default ContactMessagesPage;